//KOInformationModal
/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2024] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';
import Ladda from 'ladda';

import { validateForm } from '@/util/ParsleyUtils';
import showErrorMessage from '@/util/showErrorMessage';
import showSuccessMessage from '@/util/ShowSuccessMessage';

import UpdateKOInformation from '../../services/UpdateKOInformation';

import tmplKOInformationModal from './KOInformationModal.hbs';

const KOInformationModal = View.extend({
  template: tmplKOInformationModal,

  className: 'ko-information-modal-view',

  ui: {
    saveBtn: '.saveBtn',
    koInformationForm: '.ko-information-form'
  },

  regions: {},

  childViewEvents: {},

  events: { 'click @ui.saveBtn': 'onClickSave' },

  onRender() {
    Syphon.deserialize(this, this.model.toJSON());
  },

  async onClickSave(e) {
    e.preventDefault();

    const spinner = Ladda.create(this.ui.saveBtn[0]);
    spinner.start();

    

    const formData = Syphon.serialize(this);
    formData.id = this.model.get('id');
    formData.address.addressId = this.model.get('address')?.addressId;
    formData.pocName = formData.pocFirstName.concat(' ', formData.pocLastName);
    const selectedRegionGroup = _.filter(this.model.get('regionGroups'), (group) => {
      return group.id === formData.regionGroupId;
    });
    formData.regionGroup = selectedRegionGroup[0]?.regionGroup;
    const selectedRegion = _.filter(this.model.get('regions'), (region) => {
      return region.id === formData.address.regionId;
    });
    formData.address.regionName = selectedRegion[0]?.name;
    formData.isActiveText = formData.isActive === '1' ? 'Active' : 'Inactive';

    try {
      await validateForm(this.ui.koInformationForm);
      formData.id = await UpdateKOInformation(formData);
      this.triggerMethod('modal:close', formData);
      showSuccessMessage({
        code: 'koSaved',
        title: 'KO Information Saved',
        message: 'The KO information has successfully been saved.',
        hideAfter: 10
      });
    } catch (err) {
      showErrorMessage({
        errorCode: 'koError',
        errorTitle: 'Error Saving KO Information',
        errorMessage: 'An error occurred while attempting to save the KO information.'
      });
    } finally {
      spinner.stop();
    }
  }
});

export default KOInformationModal;
